
import { ApiProperty } from "@nestjs/swagger";


export class EmployeeCodesRequest {
    @ApiProperty()
    employeeCodes: string[];

    constructor(employeeCodes: string[]) {
        this.employeeCodes = employeeCodes
    }
}